var lib_core      = require("lib-core");
var THREE         = require("three");
var LocalRotationModel  = require("./../abstract/localRotationHandleModel.js");

var LocalXRotationModel = function (editorModel, handleId, config) {
    LocalRotationModel.call(this, editorModel, handleId, config);
};

lib_core.inherit(LocalXRotationModel, LocalRotationModel);
LocalXRotationModel.$class = "LocalXRotationModel";
module.exports = LocalXRotationModel;


LocalXRotationModel.prototype.released = function(){
    this.selected(false);
}

LocalXRotationModel.prototype.createMovementPlane = function(ray, point){
    var subject = this.getSubject();
    var newRay = new THREE.Vector3(1,0,0);
    var zero = new THREE.Vector3();
    var pos = subject.getPosition();
    var vecToOrigin = new THREE.Vector3( pos.x, pos.y, pos.z );
    var distanceToOrigin = zero.distanceTo(vecToOrigin);
    vecToOrigin.normalize();
    var dotProduct = vecToOrigin.dot(newRay);
    var angle = Math.acos(dotProduct);
    var adjLength = distanceToOrigin * Math.cos(angle);
    this.movementPlane.setComponents(newRay.x, newRay.y, newRay.z, -adjLength);
}

LocalXRotationModel.prototype.setContactPosition = function(position){
    this.selected(true);
    var subject = this.getSubject();
    this.startRotation = subject.getRotation().x;
    var basePos = subject.getPosition();

    var vectorToCenter = position.sub(basePos);
    vectorToCenter.normalize();

    var angle = Math.atan2(vectorToCenter.z, vectorToCenter.y);
    this.startAngle = angle;
}

LocalXRotationModel.prototype.setMousePosition = function(position){

    var subject = this.getSubject();
    var basePos = subject.getPosition();
    var vectorToCenter = position.sub(basePos);

    var vecLength = vectorToCenter.length();
    vectorToCenter.normalize();
    var newAngle = Math.atan2(vectorToCenter.z, vectorToCenter.y);

    var absangle = (newAngle - this.startAngle) + ((this.startRotation)*(Math.PI/180));
    var snapcount = Math.round((absangle)/(Math.PI/2));
    var snapnum = snapcount * Math.PI/2;

    if(this.snapped()){
        if(Math.abs(absangle - snapnum) < 0.1){
            subject.inspectorRotationX(snapnum* (180/Math.PI));
        } else {
            var angleDiff = newAngle - this.startAngle;
            subject.inspectorRotationX( this.startRotation + parseFloat((angleDiff) * 180 / Math.PI));
            this.snapped(false);
        }
    } else {
        if(Math.abs(absangle - snapnum) < 0.01){
            subject.inspectorRotationX(snapnum* (180/Math.PI));
            this.snapped(true);
        } else {
            var angleDiff = newAngle - this.startAngle;
            subject.inspectorRotationX( this.startRotation + parseFloat((angleDiff) * 180 / Math.PI));
        }
    }
}


